import styled from 'styled-components';
import colors from 'modules/colors';

export const Item = styled.p`
    font-size: 12px;
    line-height: 15px;
    color: ${() => colors.black}
    padding-left: 4px;
`;
